export default __webpack_public_path__ + "static/media/circle.2cde0847.svg";